module.exports = __webpack_public_path__ + "static/media/defaultChannelLogo.6913b4f8.png";